module.exports = __webpack_public_path__ + "img/hazenpeper.b046385c.jpg";